import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessagePageComponent } from './message-page.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MessagePageComponent],
  exports: [MessagePageComponent],
})
export class MessagePageModule {}
